import { render, staticRenderFns } from "./AddGroupModal.vue?vue&type=template&id=1d228824&scoped=true"
import script from "./AddGroupModal.vue?vue&type=script&lang=js"
export * from "./AddGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d228824",
  null
  
)

export default component.exports